import { Chip } from "@mui/material";

/** 未読（初回表示）の印。 */
export const NewChip: React.FC = () => (
  <Chip
    label="NEW"
    size="small"
    color="primary"
    sx={{
      height: 18,
      mb: 0.5,
      fontSize: 10,
      fontWeight: 700,
      "& .MuiChip-label": { px: 0.75 },
    }}
  />
);
